export const apiUrl = process.env.REACT_APP_API_HOST + '/api/v1/';
export const baseUrl = process.env.REACT_APP_API_HOST;